import { animate, query, stagger, state, style, transition, trigger } from '@angular/animations';

export const subMenuStaggerAnimation = trigger('subMenuStaggerAnimation', [
  transition('* => *', [
    query(':leave', [animate('150ms', style({ opacity: 0, transform: 'translateY(0px)' }))], {
      optional: true,
    }),
    query(
      ':enter',
      [
        style({ opacity: 0, transform: 'translateY(-14px)' }),
        stagger('20ms', [
          animate('150ms 150ms cubic-bezier(0, 0, 0, .8)', style({ opacity: 1, transform: 'translateY(0)' })),
        ]),
      ],
      { optional: true },
    ),
  ]),
]);

export const subMenuWidth = trigger('subMenuWidth', [
  state(
    'void',
    style({
      width: 0,
    }),
  ),
  state(
    '*',
    style({
      width: '185px',
    }),
  ),
  transition('void <=> *', animate('360ms cubic-bezier(0.6, 0, 0, 1)')),
]);
